'use client'
import { useEffect } from 'react'
import { serialize } from 'cookie'
import { useIsProduction } from 'hooks/useIsProduction'
import { getRootDomain } from 'utils/cookie/cookie'

export type CookieProps = {
  name: string
  value: string
  needsSetting: boolean
  isRootDomain?: false
  options?: {
    maxAge?: number
    path?: string
    domain?: string
    secure?: boolean
    httpOnly?: boolean
    expires?: Date
    sameSite?: string
  }
}

export type SetClientCookieProps = {
  cookies: CookieProps[]
}

const SetClientCookie = ({ cookies }: SetClientCookieProps) => {
  const isProduction = useIsProduction()
  useEffect(() => {
    cookies?.forEach((cookie) => {
      if (cookie.needsSetting) {
        const rootDomain = getRootDomain(window.location.hostname)
        const defaultOptions = {
          path: '/',
          secure: isProduction ? true : false,
          sameSite: 'lax',
        }
        const serializedCookie = serialize(cookie.name, cookie.value, {
          ...defaultOptions,
          ...(cookie.isRootDomain ? { domain: rootDomain } : {}),
          ...cookie.options,
        })
        document.cookie = serializedCookie
      }
    })
  }, [cookies, isProduction])

  return null
}

export default SetClientCookie
